import { ReactNode } from "react";
import { PackageProgressStepper } from "./PackageProgressStepper";

interface StepWrapperProps {
  currentStep: number;
  completedSteps?: number[];
  onStepClick?: (step: number) => void;
  isStepRequired?: (step: number) => boolean;
  children: ReactNode;
}

export const StepWrapper = ({
  currentStep,
  completedSteps = [],
  onStepClick = () => {},
  isStepRequired = () => true,
  children
}: StepWrapperProps) => {
  return (
    <div>
      {children}
      
      {/* Progress Stepper */}
      <PackageProgressStepper 
        currentStep={currentStep} 
        completedSteps={completedSteps}
        onStepClick={onStepClick}
        isStepRequired={isStepRequired}
      />
    </div>
  );
};